import { createContext, useContext, useState } from 'react';
type PaginationContextType = {
  currentPage: number;
  totalPage: number;
  questionPageCount: number;
  answerPageCount: number;
  handleCurrentPageChange: (page: number) => void;
  handleQuestionPageRenderComplete: (pageNumber: number) => void;
  handleAnswerPageRenderComplete: (pageNumber: number) => void;
  handleAnswerPageIncludeChange: (shouldInclude: boolean) => void;
};
const paginationContext = createContext<PaginationContextType>({
  currentPage: 1,
  totalPage: 1,
  questionPageCount: 0,
  answerPageCount: 0,
  handleCurrentPageChange: () => {},
  handleQuestionPageRenderComplete: () => {},
  handleAnswerPageRenderComplete: () => {},
  handleAnswerPageIncludeChange: () => {}
});
export const PaginationContext = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [questionPageCount, setQuestionPageCount] = useState(0);
  const [answerPageCount, setAnswerPageCount] = useState(0);
  const handleCurrentPageChange = (page: number) => {
    setCurrentPage(page);
  };
  const handleQuestionPageRenderComplete = (pageNumber: number) => {
    setQuestionPageCount(pageNumber);
  };
  const handleAnswerPageRenderComplete = (pageNumber: number) => {
    !answerPageCount && setAnswerPageCount(pageNumber);
  };
  const handleAnswerPageIncludeChange = (shouldInclude: boolean) => {
    if (shouldInclude) {
      setTotalPage(questionPageCount + answerPageCount);
    } else {
      setTotalPage(questionPageCount);
    }
  };
  return <paginationContext.Provider value={{
    currentPage,
    totalPage,
    questionPageCount,
    answerPageCount,
    handleCurrentPageChange,
    handleQuestionPageRenderComplete,
    handleAnswerPageRenderComplete,
    handleAnswerPageIncludeChange
  }} data-sentry-element="unknown" data-sentry-component="PaginationContext" data-sentry-source-file="PaginationContext.tsx">
      {children}
    </paginationContext.Provider>;
};
export const usePaginationContext = () => {
  const context = useContext(paginationContext);
  if (!context) {
    throw new Error('PaginationContext not found');
  }
  return context;
};